import { isMarkAsSpamMessage, isBlockMessage, isUnblockMessage, isUnmarkAsSpamMessage
// @ts-expect-error module not typed
} from 'conversations-message-history/filtered-change-message/operators/filteredChangeComparators';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const chooseFilteredChangeSystemMessage = ({
  message,
  isSelfMarker,
  marker
}) => {
  if (isSelfMarker) {
    if (isBlockMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-inbox-message-history.filtered-change.threadLabels.you.blocked',
        options: {
          marker
        }
      });
    }
    if (isUnblockMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.you.unblocked`,
        options: {
          marker
        }
      });
    }
    if (isMarkAsSpamMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.you.markedAsSpam`,
        options: {
          marker
        }
      });
    }
    if (isUnmarkAsSpamMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.you.unmarkedAsSpam`,
        options: {
          marker
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `conversations-inbox-message-history.filtered-change.threadLabels.you.default`,
      options: {
        marker
      }
    });
  } else {
    if (isBlockMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.agent.blocked`,
        options: {
          marker
        }
      });
    }
    if (isUnblockMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.agent.unblocked`,
        options: {
          marker
        }
      });
    }
    if (isMarkAsSpamMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.agent.markedAsSpam`,
        options: {
          marker
        }
      });
    }
    if (isUnmarkAsSpamMessage(message)) {
      return /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `conversations-inbox-message-history.filtered-change.threadLabels.agent.unmarkedAsSpam`,
        options: {
          marker
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `conversations-inbox-message-history.filtered-change.threadLabels.agent.default`,
      options: {
        marker
      }
    });
  }
};